import axios from "axios";
import AuthService from "../../Admin/services/AuthService";

const API_URL = process.env.REACT_APP_API_URL;

axios.interceptors.request.use((config) =>
  AuthService.prepareAuthenticatedRequest(config)
);

function unwrap(data) {
  if (data && Array.isArray(data.$values)) return data.$values;
  return data;
}

const MessagingIntegrationService = {
  getByClientId: async (clientId) => {
    const response = await axios.get(
      `${API_URL}/ClientMessagingConfig/GetClientMessagingConfigByClientId/${clientId}`
    );
    return unwrap(response.data);
  },

  create: async (payload) => {
    const response = await axios.post(`${API_URL}/ClientMessagingConfig/CreateClientMessagingConfig`, payload);
    return response.data;
  },

  update: async (payload) => {
    const response = await axios.put(
      `${API_URL}/ClientMessagingConfig/UpdateClientMessagingConfig/${payload.id}`,
      payload
    );
    return response.data;
  },

  deleteConfig: async (id) => {
    const response = await axios.delete(`${API_URL}/ClientMessagingConfig/DeleteClientMessagingConfig/${id}`);
    return response.data;
  },
};

export default MessagingIntegrationService;
